import { AREA_IMPACTED_OPTIONS } from './validationSchema';

export const getAreaImpactedFromLocation = () => {
	const path = window.location.pathname.toLowerCase();
	const match = AREA_IMPACTED_OPTIONS.find(({ value }) => {
		if (value === 'Other') return false;
		const slug = value.toLowerCase().replace(/\s+/g, '-');
		return path.includes(slug);
	});
	return match?.value ?? 'Other';
};

export const buildSupportTicketPrefill = ({
	subject,
	errorMessage,
	areaImpacted,
} = {}) => {
	const resolvedSubject = subject || errorMessage || '';
	const description = `${errorMessage}\n\nLink: ${window.location.href}`;

	return {
		subject: resolvedSubject,
		category: 'FOLIO App Issue',
		areaImpacted: areaImpacted ?? getAreaImpactedFromLocation(),
		description,
	};
};
